import { render } from "./RecordSummary.vue?vue&type=template&id=0c2c3f0c"
import script from "./RecordSummary.vue?vue&type=script&lang=js"
export * from "./RecordSummary.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__